/**
 *
 * @param filename - Base filename without extension for exported files
 * @returns
 */
export const getExportOptions = (filename: string) => ({
  png: { filename: `${filename}.png`, pixelRatio: 5 },
  csv: { filename: `${filename}.csv` },
  xlsx: { filename: `${filename}.xlsx` }
});
